import jQuery from 'jquery';
import Modal from './bootstrap/modal';

interface OpenPaperformParams {
  prefill?: Record<string, string>;
}

export function openPaperform(formId: string, params?: OpenPaperformParams) {
  // Is this form being globally substituted with a different form?
  formId = window.paperformSubstitutions[formId] || formId;

  // Is this form already populated in a hidden popup?
  const formElementId = `paperform-${formId}`;
  const formElement = document.getElementById(formElementId);

  if (formElement !== null) {
    let modal: HTMLElement | null = formElement;
    do {
      if (modal.classList.contains('modal')) break;
      modal = modal.parentElement;
    } while (modal !== null);

    if (modal !== null) {
      Modal._jQueryInterface.call(jQuery(modal), 'show');
      return;
    }
  }

  params = params ? params : window.paperformDefaults[formId] || {};

  const prefill: Record<string, string> = params.prefill ?? {};

  const referrer = decodeURIComponent(window.getCookie('referrer'));
  const clickId = window.getCookie('clickid');
  const utmVars = window.getCookie('utmvars');
  const platform = window.isMobile() ? 'mobile' : 'desktop';
  const gaClientId = getGAClientId();

  if (referrer) {
    prefill.referrer = referrer;
  }

  if (utmVars) {
    prefill.utmvars = utmVars;
  }

  if (clickId) {
    prefill.clickid = clickId;
  }

  if (gaClientId) {
    prefill.clientid = gaClientId;
  }

  prefill.platform = platform;

  const tzOffsetHours = Math.round(new Date().getTimezoneOffset() / -60);
  prefill.timezoneOffset = tzOffsetHours >= 0 ? `GMT+${tzOffsetHours}` : `GMT${tzOffsetHours}`;

  try {
    prefill.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch {
    prefill.timezone = `Etc/${prefill.timezoneOffset}`;
  }

  // Strip the query params for privacy.
  const path = new URL(document.location.href);
  path.search = '';
  prefill.embedURL = path.href;

  // Prefill query params
  const u = new URL(document.location.href);
  u.searchParams.forEach((value, key) => (prefill[key] = value));

  // TOOD: Add synthetic import for Paperform
  // @ts-expect-error Paperform function not found
  Paperform.popup(formId, { prefill: prefill });
}

function getGAClientId() {
  return window.getCookie('_gcl_au')?.replace(/^(?:GA)?1\.1\./, '');
}
